<template>
	<section class="services-section" id="stages">
		<div class="title">
			<h3 class="h-text">
				<span>Сервис</span>
				<span class="h-text2"> «под ключ»</span>
			</h3>

			<p>
				Берем на себя ответственность за каждый этап перевозки: от
				отправки груза из Китая до получения товара клиентом
			</p>
		</div>

		<ul>
			<li
				v-for="(step, idx) in steps"
				:key="step.description"
				class="scroll-animation"
			>
				<span>0{{ idx + 1 }}</span>
				<p>{{ step.description }}</p>
				<UIShIcon name="arrow-up-right" class="icon" />
			</li>
		</ul>
	</section>
</template>

<script setup lang="ts">
const steps = [
	{
		description:
			'Составление юридически правильного договора \nс производителем',
		link: ''
	},
	{ description: 'Выкуп и забор груза \nу поставщика', link: '' },
	{
		description: 'Транспортировочная упаковка \nи подготовка к отправке',
		link: ''
	},
	{ description: 'Хранение на складе', link: '' },
	{ description: 'Страхование груза', link: '' },
	{
		description: 'Полное таможенное сопровождение',
		link: ''
	},
	{
		description: 'Доставка по всей России, \nтакже возможен самовывоз',
		link: ''
	}
];
</script>

<style lang="scss" scoped>
.services-section {
	padding: 0.889rem 0.667rem;
	margin-top: 4.444rem;
	border-radius: 1.111rem;
	background-color: var(--color-gray900);
}

.title {
	margin-top: 0.889rem;
	color: var(--color-white);

	.h-text {
		max-width: 15.889rem;
		@include useFont(dxsb);
		text-transform: uppercase;

		&2 {
			color: var(--color-gray300);
		}
	}

	p {
		max-width: 18.667rem;
		margin-top: 0.444rem;
		@include useFont(tmdm);
	}
}

ul {
	margin-top: 2.222rem;
	color: var(--color-gray300);
	@include useFont(tmdm);

	li {
		display: flex;
		flex-direction: column;
		gap: 0.889rem;
		padding-block: 0.889rem;
		border-top: 0.056rem solid var(--color-white10);
		white-space: pre-line;
		position: relative;

		--icon-width: 1.333rem;
		--icon-height: 1.333rem;

		.icon {
			position: absolute;
			top: 0.889rem;
			right: 0;
		}
	}
}

@include screen1920 {
	.services-section {
		padding: 2.667rem;
		margin-top: 7.778rem;
		border-radius: 1.333rem;
		padding-bottom: 0;
	}

	.title {
		margin-top: 0;
		display: flex;
		flex-wrap: nowrap;
		gap: 1.111rem;
		justify-content: space-between;

		.h-text {
			max-width: 47.889rem;
			@include useFont(dxlb);
		}

		p {
			max-width: 29.111rem;
			margin-top: 0.556rem;
			margin-right: 1.556rem;
			@include useFont(dxsm);
		}
	}

	ul {
		margin-top: 4.444rem;
		@include useFont(dsmm);

		li {
			display: grid;
			column-gap: 9.778rem;
			padding-block: 2.222rem;
			grid-template-columns: 4.778rem 1fr 2.278rem;

			--icon-width: 2.278rem;
			--icon-height: 2.278rem;
		}
	}
}
</style>
